import { createGlobalStyle } from 'styled-components';
import PoppinsBold from '../assets/fonts/Poppins/Poppins-Bold.ttf';
import PoppinsMedium from '../assets/fonts/Poppins/Poppins-Medium.ttf';
import PoppinsSemiBold from '../assets/fonts/Poppins/Poppins-SemiBold.ttf';
import PoppinsRegular from '../assets/fonts/Poppins/Poppins-Regular.ttf';

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Poppins Bold';
    src: url(${PoppinsBold}) format('truetype');
    font-style: normal;
    font-display: auto;
  }
  @font-face {
    font-family: 'Poppins Medium';
    src: url(${PoppinsMedium}) format('truetype');
    font-style: normal;
    font-display: auto;
 }
 @font-face {
    font-family: 'Poppins SemiBold';
    src: url(${PoppinsSemiBold}) format('truetype');
    font-style: normal;
    font-display: auto;
 }
 @font-face {
    font-family: 'Poppins Regular';
    src: url(${PoppinsRegular}) format('truetype');
    font-style: normal;
    font-display: auto;
 }
`;

export default GlobalStyle;